import * as React from "react";
const SvgShape = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M5.99016 5.98918C6.38069 5.59866 7.01385 5.59866 7.40438 5.98918L12.0006 10.5854L16.5968 5.98919C16.9873 5.59866 17.6204 5.59866 18.011 5.98919C18.4015 6.37971 18.4015 7.01287 18.011 7.4034L13.4148 11.9996L18.011 16.5958C18.4016 16.9864 18.4016 17.6195 18.011 18.0101C17.6205 18.4006 16.9873 18.4006 16.5968 18.0101L11.9999 13.4145L7.40437 18.01C7.01385 18.4005 6.38068 18.4005 5.99016 18.01C5.59963 17.6195 5.59963 16.9863 5.99016 16.5958L10.5856 12.0003L5.99016 7.4034C5.59964 7.01288 5.59964 6.37971 5.99016 5.98918Z",
	fill: "#969FA8"
}));
export default SvgShape;
